/** Cart badge count. Always null in 001 (no badge); feature 009 supplies the count (FR-007). */
export function useCartCount(): number | null {
  return null;
}
